/*!

=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import {
  Route,
  Routes,
  Navigate,
  unstable_HistoryRouter as HistoryRouter,
} from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import RtlLayout from "layouts/RTL.js";
import AdminLayout from "layouts/Admin.js";
import ErrorBoundary from "./components/ErrorBoundary/index.js";
import { NotificationProvider } from "./components/Notification/index.js";
import Loading from "./components/Loading/index.js";

import "@lukos-tecnologia/ui/styles/tokens-and-primitives.css";
import "@lukos-tecnologia/ui/styles/ui-primitives.css";
import "@lukos-tecnologia/ui/styles/select-premium.css";
import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";
import "styles/lukos-fatura.css";
import "styles/lukos-admin-shell.css";

import history from "./history.js";

// Remove qualquer service worker antigo (versões anteriores do template
// registravam um) que ficava servindo assets em cache e forçava o usuário a
// dar Ctrl+Shift+R a cada atualização. Idempotente e seguro.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
  if (window.caches && caches.keys) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

const isLogged = !!localStorage.getItem("lukos-token-fw");

if (isLogged === false) {
  history.push("/login");
}

const root = createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Suspense fallback={<Loading fullScreen />}>
      <NotificationProvider>
        <HistoryRouter history={history}>
          <Routes>
            <Route path="/rtl/*" element={<RtlLayout />} />
            <Route path="/auth/*" element={<AuthLayout />} />
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/login" element={<Navigate to="/auth/login-page" replace />} />
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
        </HistoryRouter>
      </NotificationProvider>
    </Suspense>
  </ErrorBoundary>
);
